import * as React from 'react';
import { Col, Form } from 'react-bootstrap';

import { FormContext } from '@/helper/context';
import { camelToTitle } from '@/helper/utility';

interface Properties {
  name: string;
  displayName?: string;
  value?: boolean;
  valueSelect?: boolean;
  setValue?: React.Dispatch<React.SetStateAction<boolean>>;
  size?: string;
  mixed?: boolean;
}

export function Switch({ name, displayName, value, valueSelect, setValue, size = '', mixed = false }: Properties) {
  displayName = displayName || camelToTitle(name);
  const [checked, setChecked] = React.useState(valueSelect ?? value ?? false);
  const [mixedActive, setMixedActive] = React.useState(!mixed);
  const { changeTracker, setWasChanged, disabled } = React.useContext(FormContext);
  const isMixed = mixed && !mixedActive;

  React.useEffect(() => {
    setMixedActive(!mixed);
  }, [mixed]);

  React.useEffect(() => {
    setChecked(valueSelect ?? value ?? false);
  }, [value, valueSelect]);

  React.useEffect(() => {
    const didChange = valueSelect ? (valueSelect == value ? false : true) : false;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }, []);

  function updateChangeTracker(nextChecked: boolean) {
    const didChange = nextChecked == value ? false : true;
    changeTracker.current = {
      ...changeTracker.current,
      [name]: didChange
    };
    setWasChanged(Object.values(changeTracker.current).includes(true));
  }

  function applyToggle(nextChecked: boolean) {
    setChecked(nextChecked);
    if (setValue) {
      setValue(nextChecked);
    }
    updateChangeTracker(nextChecked);
  }

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    applyToggle(event.target.checked);
  }

  function handleMixedActivate() {
    if (!isMixed || disabled) return;
    setMixedActive(true);
    applyToggle(!checked);
  }

  return (
    <Col className={`mt-3 ${size}`} onClick={handleMixedActivate}>
      <Form.Check
        type='switch'
        id={name}
        name={name}
        label={displayName}
        checked={checked}
        onChange={onChange}
        disabled={disabled || isMixed}
      />
    </Col>
  );
}
